import React from 'react';

export const GraphSkeleton: React.FC<{ title?: string }> = ({ title }) => (
  <div
    className="flex h-full min-h-[16rem] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-rowing-gray-200 bg-rowing-gray-50 p-6 text-center"
    data-testid="graph-skeleton"
  >
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-rowing-blue border-t-transparent" />
    <div className="space-y-1">
      <p className="text-sm font-medium text-rowing-gray-600">
        {title ?? 'Preparing visualization'}
      </p>
      <p className="text-xs text-rowing-gray-500">Data is loading…</p>
    </div>
  </div>
);

export const GraphEmptyState: React.FC<{ title?: string; message?: string }> = ({
  title,
  message,
}) => (
  <div
    className="flex h-full min-h-[16rem] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-rowing-gray-200 bg-rowing-gray-50 p-6 text-center"
    data-testid="graph-empty"
  >
    <div className="text-2xl">ℹ️</div>
    <div className="space-y-1">
      <p className="text-sm font-medium text-rowing-gray-600">{title ?? 'No data available yet'}</p>
      <p className="text-xs text-rowing-gray-500">
        {message ?? 'Upload telemetry or adjust filters to populate this graph.'}
      </p>
    </div>
  </div>
);

export const GraphErrorState: React.FC<{
  title?: string;
  error?: string;
  onRetry?: () => void;
}> = ({ title, error, onRetry }) => (
  <div
    className="flex h-full min-h-[16rem] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-red-200 bg-red-50 p-6 text-center"
    data-testid="graph-error"
  >
    <div className="text-2xl">⚠️</div>
    <div className="space-y-1">
      <p className="text-sm font-semibold text-red-700">
        {title ?? 'Unable to load visualization'}
      </p>
      {error ? <p className="text-xs text-red-600">{error}</p> : null}
    </div>
    {onRetry ? (
      <button
        type="button"
        onClick={onRetry}
        className="rounded-md border border-red-300 bg-white px-3 py-1 text-sm font-medium text-red-700 transition hover:bg-red-100"
      >
        Retry
      </button>
    ) : null}
  </div>
);
